import {match} from 'ts-pattern';

import type {InterestLifecycleState} from '@prompt-bridge/shared/ai-assistant-core';

type DmsInterestLifecycleState = 'NEW' | 'OPEN' | 'CLOSED' | 'UNSUCCESSFUL';

export const toInterestLifecycleState = (
  state: DmsInterestLifecycleState
): InterestLifecycleState =>
  match(state)
    .returnType<InterestLifecycleState>()
    .with('NEW', () => 'new')
    .with('OPEN', () => 'open')
    .with('CLOSED', () => 'closed')
    .with('UNSUCCESSFUL', () => 'unsuccessful')
    .exhaustive();
